/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommentTextArea/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TasksCommentTextarea from 'DesignSystem/TasksCommentTextarea/index'



/** @type {import('Simple/types.js').View} */
export default function CommentTextArea({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Comment/CommentTextArea",
  onChange
  
}) {
let taskCommentCommentValueData = fromData.useDataValue({ viewPath,
context: 'task_comment',
path: 'comment',
})
let taskCommentCommentChangeData = fromData.useDataChange({ viewPath,
context: 'task_comment',
path: 'comment',
})
  return (<React.Fragment
>
<TasksCommentTextarea
  viewPath={`${viewPath}/TasksCommentTextarea`}
 data="task_comment.comment"
 value={taskCommentCommentValueData}
 onChange={taskCommentCommentChangeData}
/>
{children}
</React.Fragment>)
}